var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvaxWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9874 11.3633C13.2808 10.794 13.7543 10.794 14.0477 11.3633L15.8748 14.9663C16.1682 15.5356 15.9281 16 15.3413 16H11.6604C11.0803 16 10.8402 15.5356 11.1269 14.9663L12.9874 11.3633ZM9.4532 4.42697C9.7466 3.85768 10.2134 3.85768 10.5068 4.42697L10.9136 5.25094L11.8738 7.14607C12.1072 7.68539 12.1072 8.3221 11.8738 8.86142L8.653 15.1311C8.3596 15.6405 7.87281 15.9625 7.33268 16H4.65869C4.07188 16 3.83182 15.5431 4.12522 14.9663L9.4532 4.42697Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvaxWhite);
export default __webpack_public_path__ + "static/media/avax-white.297fc061531dbb71fbefd2d06a5e9333.svg";
export { ForwardRef as ReactComponent };